import React from 'react';
import Assert from '../assert/Assert';
import {BootstrapForm, FormGroup} from './bootstrap/Form';

var getInitialEmails = (emails) => {
    var mappedEmails = emails.map(e => ({id: e.id, value: e.email}));
    return mappedEmails.length ? mappedEmails : [{value:''}];
};

var getInitialPhoneNumbers = (numbers) => {
    var mappedPhoneNumbers = numbers.map(n => ({id: n.id, value: n.number}));
    return mappedPhoneNumbers.length ? mappedPhoneNumbers : [{value:''}];
};

export default class ClientContactForm extends React.Component {
    constructor(props) {
        super(props);

        console.log('props are', props);

        this.state = {
            isSaving: false,
            inputs: {
                firstName: {
                    value: props.isEditing ? props.firstName : '',
                    validators: props.noValidate ? [] : [{
                        rule: Assert.minLength(1),
                        errorMessage: 'First name must be at least 1 character long'
                    }]
                },
                lastName: {
                    value: props.isEditing ? props.lastName : '',
                    validators: this.props.noValidate ? [] : [{
                        rule: Assert.minLength(1),
                        errorMessage: 'Last name must be at least 1 character long'
                    }]
                },
                description: {
                    value: props.isEditing ? props.description : '',
                    validators: []
                },
                emails: {
                    value: props.isEditing ? getInitialEmails(props.emails) : [{value:''}]
                },
                phones: {
                    value: props.isEditing ? getInitialPhoneNumbers(props.numbers) : [{value: ''}]
                }
            },
            errors: {},
            showEmail : props.showEmail == undefined || props.showEmail,
            showDescription : props.showDescription == undefined || props.showDescription
        };
    }
    handleInputChange(e) {
        var inputs = this.state.inputs;
        inputs[e.target.name].value = e.target.value;
        this.setState({inputs});
    }
    addEmail() {
        var inputs = this.state.inputs;
        inputs.emails.value.push({value:''});
        this.setState({inputs});
    }
    addPhoneNumber() {
        var inputs = this.state.inputs;
        inputs.phones.value.push({value:''});
        this.setState({inputs});
    }
    handleChangeInContactItem(type, index, contactId, e) {
        var inputs = this.state.inputs;
        inputs[type].value[index] = contactId ? {id: contactId, value: e.target.value} : {value: e.target.value};
        this.setState({inputs});
    }
    isValid() {
        var isValid = this.refs.form.isValid();
        if(! isValid) {
            this.setState({errors: this.refs.form.getErrors()});
        }
        return isValid;
    }
    getFormData() {
        return this.refs.form.getFormData();
    }
    handleSubmit(e) {
        e.preventDefault();
        this.exposeFormData();
    }
    exposeFormData() {
        if(this.refs.form.isValid()) {
            this.props.onSubmit(
                this.refs.form.getFormData()
            );
        } else {
            this.setState({errors: this.refs.form.getErrors()});
        }
    }
    render() {
        return (
            <BootstrapForm ref="form" onSubmit={this.handleSubmit.bind(this)} inputs={this.state.inputs} className="form-horizontal">
                <FormGroup defaultText='First name' errors={this.state.errors.firstName}>
                    <input type="text"
                           name='firstName'
                           className="form-control"
                           onChange={this.handleInputChange.bind(this)}
                           value={this.state.inputs.firstName.value}
                           placeholder="Enter first name" />
                </FormGroup>
                <FormGroup defaultText='Last name' errors={this.state.errors.lastName}>
                    <input type="text"
                           name='lastName'
                           className="form-control"
                           onChange={this.handleInputChange.bind(this)}
                           value={this.state.inputs.lastName.value}
                           placeholder="Enter last name" />
                </FormGroup>
                {this.state.showDescription &&
                    <FormGroup defaultText='Description' errors={this.state.errors.description}>
                        <input type="text"
                               name='description'
                               className="form-control"
                               onChange={this.handleInputChange.bind(this)}
                               value={this.state.inputs.description.value}
                               placeholder="Enter description" />
                    </FormGroup>
                }

                {this.state.inputs.phones.value.map((phone, i, phones) => {
                    var phoneId = phone.id ? phone.id : false;
                    return (
                        <div className="form-group" key={i}>
                            <label className="control-label col-md-3" htmlFor={'phone' + i}>
                                <span style={{marginRight: '5px'}}>{phones.length == 1 ? 'Phone ' : `Phone ${i+1}`}</span>
                                <a onClick={this.addPhoneNumber.bind(this)} className="fa fa-plus cursor-pointer"></a>
                            </label>
                            <div className="col-md-9">
                            <input
                                className='form-control'
                                key={'phone' + i}
                                type='text'
                                name={'phone' + i}
                                label='Phone'
                                placeholder='Phone Number'
                                onChange={this.handleChangeInContactItem.bind(this, 'phones', i, phoneId)}
                                value={phone.value} />
                            </div>
                        </div>
                    );
                })}
                
                {   
                    this.state.showEmail && 
                    <div>
                    {this.state.inputs.emails.value.map((email, i, emails) => {
                        var emailId = email.id ? email.id : false;
                        return (
                            <div className="form-group" key={i}>
                                <label className="control-label col-md-3" htmlFor={'email' + i}>
                                    <span style={{marginRight: '5px'}}>{emails.length == 1 ? 'Email' : `Email ${i+1}`}</span>
                                    <a onClick={this.addEmail.bind(this)} className="fa fa-plus cursor-pointer"></a>
                                </label>
                                <div className="col-md-9">
                                    <input
                                        className='form-control'
                                        key={'email' + i}
                                        type='text'
                                        name={'email' + i}
                                        label='Email'
                                        placeholder='Email'
                                        onChange={this.handleChangeInContactItem.bind(this, 'emails', i, emailId)}
                                        value={email.value} />
                                </div>
                            </div>
                        );
                    })}
                    </div>
                }                
            </BootstrapForm>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/ClientContactForm.js